// // This file is auto-generated by ./bin/rails stimulus:manifest:update
// // Run that command whenever you add a new controller or create them with
// // ./bin/rails generate stimulus controllerName
//
// import { application } from "./application"
//
// import HelloController from "./hello_controller"
// application.register("hello", HelloController)

import { application } from './application'
import { registerControllers } from 'stimulus-vite-helpers'

// Controller files must be named *_controller.js.
const controllers  = import.meta.glob('./**/*_controller.{js,jsx}', { eager: true })
registerControllers(application, controllers)
